import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management');
import { validEmail, normalizePhone } from "src/libs/portal/season/contact-detail-policy";
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ip-management',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management/view.scss */
:host {
  display: block;
  min-height: 100%;
  width: 100%;
}

.management-page {
  --ink: #102623;
  --muted: #697a76;
  --green: #0f6b5a;
  --green-dark: #0a453c;
  background: #f7f9f6;
  color: var(--ink);
  min-height: 100%;
  width: 100%;
}

.management-wrap {
  margin: 0 auto;
  max-width: 1256px;
  width: 100%;
}

.management-hero {
  background: linear-gradient(135deg, #0c352f 0%, #102b28 58%, #132c2c 100%);
  color: #fff;
  min-height: 430px;
  overflow: hidden;
  position: relative;
}

.management-hero::before {
  background: radial-gradient(circle, rgba(112, 212, 164, 0.17), transparent 68%);
  content: "";
  height: 520px;
  position: absolute;
  right: -60px;
  top: -210px;
  width: 520px;
}

.management-hero__pattern {
  background-image: linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
  background-size: 56px 56px;
  inset: 0;
  mask-image: linear-gradient(90deg, transparent, #000 48%, #000);
  position: absolute;
}

.management-hero__inner {
  align-items: center;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(380px, 0.9fr);
  min-height: 430px;
  padding: 54px 32px 58px;
  position: relative;
}

.management-hero__copy {
  animation: panel-rise 620ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
  position: relative;
  z-index: 2;
}

.back-link {
  align-items: center;
  background: transparent;
  border: 0;
  color: rgba(255, 255, 255, 0.58);
  display: inline-flex;
  font-size: 11px;
  font-weight: 650;
  gap: 7px;
  margin-bottom: 25px;
  padding: 0;
  transition: color 160ms ease, transform 160ms ease;
}

.back-link:hover {
  color: #fff;
  transform: translateX(-3px);
}

.back-link svg {
  height: 18px;
  width: 18px;
}

.management-kicker {
  align-items: center;
  color: #a8d4c2;
  display: flex;
  font-size: 9px;
  font-weight: 750;
  gap: 10px;
  letter-spacing: 0.16em;
  margin-bottom: 14px;
}

.management-kicker__line {
  background: rgba(168, 212, 194, 0.4);
  height: 1px;
  width: 24px;
}

.management-hero h1 {
  font-size: clamp(42px, 4.1vw, 58px);
  font-weight: 740;
  letter-spacing: -0.055em;
  line-height: 1.08;
  margin: 0;
}

.management-hero__copy > p {
  color: rgba(235, 247, 241, 0.7);
  font-size: 14px;
  line-height: 1.72;
  margin: 18px 0 0;
}

.management-hero__actions {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-top: 27px;
}

.hero-primary,
.hero-secondary {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  height: 44px;
  justify-content: center;
  padding: 0 19px;
  text-decoration: none;
  transition: transform 180ms ease, background 180ms ease;
}

.hero-primary {
  background: #a4e5c6;
  border: 0;
  color: #0a382f;
}

.hero-primary:hover {
  background: #b5efd5;
  transform: translateY(-2px);
}

.hero-secondary {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #fff;
  gap: 7px;
}

.hero-secondary:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

.hero-secondary svg {
  height: 17px;
  width: 17px;
}

.management-hero__visual {
  animation: visual-in 800ms 100ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
  height: 100%;
  inset: 0;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 0;
}

.management-hero__visual::before {
  background: linear-gradient(90deg, rgba(6, 48, 41, 0.96) 0%, rgba(7, 50, 43, 0.9) 27%, rgba(7, 47, 41, 0.62) 49%, rgba(6, 38, 34, 0.2) 76%, rgba(5, 31, 29, 0.1) 100%);
  content: "";
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.management-hero__visual::after {
  background: rgba(7, 37, 33, 0.1);
  content: "";
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 3;
}

.management-hero__visual img {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center 46%;
  width: 100%;
}

.visual-document-marker {
  align-items: center;
  backdrop-filter: blur(8px);
  background: rgba(21, 85, 72, 0.72);
  border: 1px solid rgba(185, 238, 212, 0.54);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
  color: #c8f4df;
  display: flex;
  height: 48px;
  justify-content: center;
  position: absolute;
  width: 48px;
  z-index: 2;
}

.visual-document-marker i {
  font-size: 20px;
}

.visual-document-marker--folder {
  right: 13%;
  top: 22%;
}

.visual-document-marker--document {
  bottom: 18%;
  right: 38%;
}

.visual-document-marker--calendar {
  bottom: 16%;
  right: 7%;
}

.management-tabs {
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid rgba(16, 38, 35, 0.1);
  box-shadow: 0 8px 30px rgba(18, 49, 43, 0.04);
  position: sticky;
  top: 76px;
  z-index: 30;
}

.management-tabs__inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0 32px;
}

.management-tabs button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #84918d;
  display: flex;
  gap: 12px;
  height: 76px;
  justify-content: center;
  position: relative;
  text-align: left;
}

.management-tabs button::after {
  background: #0f6b5a;
  bottom: -1px;
  content: "";
  height: 3px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%) scaleX(0);
  transition: transform 220ms ease;
  width: 92px;
}

.management-tabs button:hover,
.management-tabs button.is-active {
  color: #123d35;
}

.management-tabs button.is-active::after {
  transform: translateX(-50%) scaleX(1);
}

.management-tabs__number {
  color: #9aa6a2;
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.management-tabs button.is-active .management-tabs__number {
  color: #2c8a6d;
}

.management-tabs__copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.management-tabs__copy strong {
  font-size: 13px;
  font-weight: 700;
}

.management-tabs__copy small {
  color: #a2aca9;
  font-size: 9px;
  font-weight: 550;
}

.management-content {
  min-height: 660px;
  padding: 76px 32px 92px;
}

.tab-panel {
  animation: panel-rise 420ms cubic-bezier(0.2, 0.72, 0.22, 1) both;
}

.section-heading {
  margin-bottom: 42px;
}

.section-heading__eyebrow {
  color: #168063;
  display: block;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.2em;
  margin-bottom: 12px;
}

.section-heading h2 {
  color: #102623;
  font-size: clamp(30px, 3vw, 42px);
  font-weight: 740;
  letter-spacing: -0.045em;
  line-height: 1.18;
  margin: 0;
}

.section-heading p {
  color: #687a75;
  font-size: 14px;
  line-height: 1.72;
  margin: 16px 0 0;
}

.section-heading__notice {
  align-items: center;
  background: #edf7f2;
  border: 1px solid #cce7dc;
  border-radius: 12px;
  color: #24453e;
  display: flex;
  gap: 12px;
  margin-top: 20px;
  max-width: 760px;
  padding: 14px 16px;
}

.section-heading__notice-label {
  background: #168063;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 5px 9px;
}

.section-heading__notice-copy {
  font-size: 14px;
  font-weight: 650;
  line-height: 1.55;
}

.definition-statement {
  background: #0f332e;
  border-radius: 26px;
  color: #fff;
  overflow: hidden;
  padding: 44px 52px;
  position: relative;
}

.definition-statement::after {
  border: 1px solid rgba(164, 229, 198, 0.18);
  border-radius: 50%;
  content: "";
  height: 230px;
  position: absolute;
  right: -65px;
  top: -105px;
  width: 230px;
}

.definition-statement__mark {
  color: #7ccaa5;
  font-family: Georgia, serif;
  font-size: 70px;
  left: 30px;
  line-height: 1;
  opacity: 0.55;
  position: absolute;
  top: 24px;
}

.definition-statement p {
  font-size: clamp(20px, 2.2vw, 28px);
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.55;
  margin: 0;
  position: relative;
  z-index: 1;
}

.definition-statement > span {
  color: rgba(255, 255, 255, 0.5);
  display: block;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.08em;
  margin-top: 20px;
}

.definition-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 18px;
}

.definition-grid article {
  background: #fff;
  border: 1px solid rgba(16, 38, 35, 0.09);
  border-radius: 20px;
  min-height: 230px;
  padding: 25px;
  position: relative;
  transition: box-shadow 220ms ease, transform 220ms ease;
}

.definition-grid article:hover {
  box-shadow: 0 18px 42px rgba(20, 56, 48, 0.08);
  transform: translateY(-4px);
}

.definition-card__index {
  color: #a1aca8;
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.12em;
  position: absolute;
  right: 22px;
  top: 21px;
}

.definition-card__icon {
  align-items: center;
  background: #e8f4ed;
  border-radius: 13px;
  color: #0f6b5a;
  display: flex;
  height: 44px;
  justify-content: center;
  margin-bottom: 23px;
  width: 44px;
}

.definition-card__icon svg {
  height: 23px;
  width: 23px;
}

.definition-grid h3 {
  font-size: 16px;
  font-weight: 720;
  letter-spacing: -0.025em;
  margin: 0;
}

.definition-grid p {
  color: #71807c;
  font-size: 12px;
  line-height: 1.65;
  margin: 10px 0 0;
}

.contract-note {
  align-items: center;
  background: #eef4f0;
  border: 1px solid #d9e7df;
  border-radius: 18px;
  display: grid;
  gap: 17px;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  margin-top: 18px;
  padding: 20px 22px;
}

.contract-note__icon {
  align-items: center;
  background: #fff;
  border-radius: 12px;
  color: #176c59;
  display: flex;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.contract-note__icon svg {
  height: 23px;
  width: 23px;
}

.contract-note strong {
  font-size: 13px;
  font-weight: 700;
}

.contract-note p {
  color: #74827e;
  font-size: 11px;
  line-height: 1.55;
  margin: 5px 0 0;
}

.contract-note button {
  align-items: center;
  background: #123b34;
  border: 0;
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  font-size: 11px;
  font-weight: 700;
  gap: 8px;
  height: 38px;
  padding: 0 15px;
}

.contract-note button svg {
  height: 17px;
  width: 17px;
}

.feature-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, 1fr);
}

.feature-card {
  background: #fff;
  border: 1px solid rgba(16, 38, 35, 0.09);
  border-radius: 20px;
  min-height: 260px;
  padding: 24px;
  transition: border-color 220ms ease, box-shadow 220ms ease, transform 220ms ease;
}

.feature-card:hover {
  border-color: rgba(15, 107, 90, 0.3);
  box-shadow: 0 20px 45px rgba(18, 54, 47, 0.08);
  transform: translateY(-4px);
}

.feature-card__head {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.feature-card__number {
  align-items: center;
  background: #e8f4ed;
  border-radius: 50%;
  color: #0f6b5a;
  display: flex;
  font-size: 10px;
  font-weight: 750;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.feature-card__tag {
  color: #96a19d;
  font-size: 8px;
  font-weight: 750;
  letter-spacing: 0.14em;
}

.feature-card h3 {
  font-size: 17px;
  font-weight: 720;
  letter-spacing: -0.03em;
  margin: 0;
}

.feature-card > p {
  color: #74827e;
  font-size: 12px;
  line-height: 1.65;
  margin: 11px 0 19px;
  min-height: 40px;
}

.feature-card ul {
  border-top: 1px solid #edf0ee;
  list-style: none;
  margin: 0;
  padding: 15px 0 0;
}

.feature-card li {
  align-items: center;
  color: #52645f;
  display: flex;
  font-size: 11px;
  gap: 8px;
  margin-top: 7px;
}

.feature-card li:first-child {
  margin-top: 0;
}

.feature-card li span {
  background: #4aaa7e;
  border-radius: 50%;
  height: 4px;
  width: 4px;
}

.feature-cta {
  align-items: center;
  background: linear-gradient(110deg, #e5f2ea, #eef4ef);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  padding: 24px 27px;
}

.feature-cta > div {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.feature-cta span {
  color: #69807a;
  font-size: 10px;
}

.feature-cta strong {
  font-size: 14px;
  font-weight: 690;
}

.feature-cta button {
  background: #0e4238;
  border: 0;
  border-radius: 999px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  height: 40px;
  padding: 0 17px;
}

.usage-steps {
  list-style: none;
  margin: 0;
  padding: 0;
}

.usage-step {
  display: grid;
  gap: 26px;
  grid-template-columns: 46px minmax(0, 1fr);
  min-height: 164px;
}

.usage-step__rail {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.usage-step__rail span {
  align-items: center;
  background: #0f6b5a;
  border: 6px solid #e4f0e9;
  border-radius: 50%;
  color: #fff;
  display: flex;
  flex: 0 0 auto;
  font-size: 9px;
  font-weight: 750;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.usage-step__rail i {
  background: linear-gradient(#8bb9a7, rgba(139, 185, 167, 0.18));
  flex: 1;
  margin: 8px 0;
  width: 1px;
}

.usage-step__content {
  border-bottom: 1px solid rgba(16, 38, 35, 0.09);
  padding: 1px 0 29px;
}

.usage-step:last-child .usage-step__content {
  border-bottom: 0;
}

.usage-step__label {
  color: #2c8a6d;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.usage-step h3 {
  font-size: 19px;
  font-weight: 720;
  letter-spacing: -0.03em;
  margin: 7px 0 0;
}

.usage-step p {
  color: #6f7f7b;
  font-size: 12px;
  line-height: 1.65;
  margin: 9px 0 13px;
}

.usage-step__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.usage-step__chips span {
  background: #edf3ef;
  border-radius: 999px;
  color: #537068;
  font-size: 9px;
  font-weight: 650;
  padding: 6px 9px;
}

.usage-summary {
  align-items: center;
  background: #102f2b;
  border-radius: 24px;
  color: #fff;
  display: grid;
  gap: 35px;
  grid-template-columns: 0.9fr 1.1fr;
  margin-top: 16px;
  overflow: hidden;
  padding: 35px 38px;
  position: relative;
}

.usage-summary::after {
  border: 1px solid rgba(164, 229, 198, 0.13);
  border-radius: 50%;
  content: "";
  height: 240px;
  left: -75px;
  position: absolute;
  top: -100px;
  width: 240px;
}

.usage-summary__visual {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.usage-summary__visual span {
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(164, 229, 198, 0.18);
  border-radius: 50%;
  display: flex;
  font-size: 9px;
  font-weight: 650;
  height: 58px;
  justify-content: center;
  width: 58px;
}

.usage-summary__visual i {
  background: rgba(164, 229, 198, 0.38);
  height: 1px;
  width: 20px;
}

.usage-summary__eyebrow {
  color: #94d6b8;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.17em;
}

.usage-summary h3 {
  font-size: 20px;
  font-weight: 680;
  letter-spacing: -0.03em;
  margin: 9px 0 0;
}

.usage-summary p {
  color: rgba(255, 255, 255, 0.62);
  font-size: 11px;
  line-height: 1.6;
  margin: 9px 0 17px;
}

.usage-summary button {
  background: #a4e5c6;
  border: 0;
  border-radius: 999px;
  color: #0a382f;
  font-size: 11px;
  font-weight: 720;
  height: 38px;
  padding: 0 16px;
}

.consultation-layout {
  align-items: start;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1.45fr) minmax(300px, 0.55fr);
}

.consultation-form-card,
.consultation-guide {
  background: #fff;
  border: 1px solid rgba(16, 38, 35, 0.09);
  border-radius: 22px;
}

.consultation-form-card {
  min-height: 610px;
  padding: 30px;
}

.form-intro {
  align-items: flex-end;
  border-bottom: 1px solid #e9eeeb;
  display: flex;
  justify-content: space-between;
  margin-bottom: 26px;
  padding-bottom: 19px;
}

.form-intro > div {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-intro > div span {
  color: #298668;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.form-intro strong {
  font-size: 17px;
  font-weight: 720;
}

.form-intro p {
  color: #8a9692;
  font-size: 9px;
  margin: 0;
}

.form-intro em,
.form-field em,
.privacy-check em {
  color: #d8554f;
  font-style: normal;
  margin-left: 3px;
}

.contract-type-fieldset {
  border: 0;
  margin: 0 0 24px;
  min-width: 0;
  padding: 0;
}

.contract-type-fieldset legend {
  align-items: baseline;
  color: #3b504a;
  display: flex;
  font-size: 11px;
  font-weight: 680;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0;
  width: 100%;
}

.contract-type-fieldset legend small {
  color: #8a9692;
  font-size: 9px;
  font-weight: 500;
}

.contract-type-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.contract-type-option {
  align-items: center;
  background: #fbfcfb;
  border: 1px solid #d8e0dc;
  border-radius: 12px;
  cursor: pointer;
  display: grid;
  gap: 9px;
  grid-template-columns: 28px minmax(0, 1fr);
  min-height: 104px;
  padding: 12px;
  position: relative;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.contract-type-option:hover {
  border-color: #84b8a5;
  transform: translateY(-1px);
}

.contract-type-option.is-selected {
  background: #f0f8f4;
  border-color: #2e8d6d;
  box-shadow: 0 0 0 2px rgba(46, 141, 109, 0.1);
}

.contract-type-option:focus-within {
  border-color: #2e8d6d;
  box-shadow: 0 0 0 3px rgba(46, 141, 109, 0.14);
}

.contract-type-option input {
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.contract-type-option input:focus-visible {
  outline: none;
}

.contract-type-option__code {
  align-items: center;
  align-self: start;
  background: #e8efeb;
  border-radius: 8px;
  color: #4a625b;
  display: flex;
  font-size: 10px;
  font-weight: 800;
  height: 28px;
  justify-content: center;
  transition: background 160ms ease, color 160ms ease;
  width: 28px;
}

.contract-type-option.is-selected .contract-type-option__code {
  background: #176e55;
  color: #fff;
}

.contract-type-option__copy {
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.contract-type-option__copy strong {
  color: #263e38;
  font-size: 11px;
  font-weight: 720;
}

.contract-type-option__copy small {
  color: #7d8d88;
  font-size: 9px;
}

.contract-type-option__price {
  display: flex;
  flex-direction: column;
  gap: 2px;
  grid-column: 1/-1;
}

.contract-type-option__price strong {
  color: #176e55;
  font-size: 15px;
  font-weight: 760;
  letter-spacing: -0.03em;
}

.contract-type-option__price small {
  color: #61756e;
  font-size: 8px;
  line-height: 1.35;
}

.contract-type-fieldset.has-error .contract-type-option {
  border-color: #d4756f;
}

.contract-type-fieldset__error {
  color: #b44640;
  font-size: 9px;
  font-weight: 600;
  margin: 7px 0 0;
}

.form-grid {
  display: grid;
  gap: 20px 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.form-field--full {
  grid-column: 1/-1;
}

.form-field > span:first-child {
  color: #3b504a;
  font-size: 11px;
  font-weight: 680;
  margin-bottom: 8px;
}

.form-field input,
.form-field textarea {
  background: #fbfcfb;
  border: 1px solid #d8e0dc;
  border-radius: 11px;
  color: #102623;
  font-family: inherit;
  font-size: 12px;
  outline: none;
  padding: 0 13px;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
  width: 100%;
}

.form-field input {
  height: 46px;
}

.form-field textarea {
  line-height: 1.65;
  min-height: 150px;
  padding-bottom: 13px;
  padding-top: 13px;
  resize: vertical;
}

.form-field input::placeholder,
.form-field textarea::placeholder {
  color: #a4aeab;
}

.form-field input:focus,
.form-field textarea:focus {
  background: #fff;
  border-color: #3b9978;
  box-shadow: 0 0 0 3px rgba(59, 153, 120, 0.1);
}

.form-field small {
  align-self: flex-end;
  color: #9aa5a1;
  font-size: 9px;
  margin-top: 6px;
}

.form-field__error {
  color: #b44640;
  font-size: 9px;
  font-weight: 600;
  margin-top: 6px;
}

.form-field [aria-invalid=true] {
  border-color: #d4756f;
}

.form-field__count {
  align-self: flex-end;
}

.consult-honeypot {
  height: 0;
  left: -10000px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  width: 0;
}

.privacy-check {
  align-items: flex-start;
  background: #f4f7f5;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  margin-top: 22px;
  padding: 14px;
}

.privacy-check input {
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.privacy-check__box {
  align-items: center;
  background: #fff;
  border: 1px solid #cbd7d1;
  border-radius: 5px;
  color: transparent;
  display: flex;
  flex: 0 0 auto;
  height: 20px;
  justify-content: center;
  margin-top: 1px;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
  width: 20px;
}

.privacy-check input:checked + .privacy-check__box {
  background: #0f6b5a;
  border-color: #0f6b5a;
  color: #fff;
}

.privacy-check input[aria-invalid=true] + .privacy-check__box {
  border-color: #d4756f;
}

.privacy-check input:focus-visible + .privacy-check__box {
  box-shadow: 0 0 0 3px rgba(15, 107, 90, 0.18);
}

.privacy-check__box svg {
  height: 14px;
  width: 14px;
}

.privacy-check > span:last-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.privacy-check strong {
  color: #425651;
  font-size: 10px;
  font-weight: 680;
}

.privacy-check small {
  color: #87938f;
  font-size: 9px;
  line-height: 1.45;
}

.privacy-check .privacy-check__error {
  color: #b44640;
  font-weight: 600;
}

.form-error {
  align-items: center;
  background: #fff2f1;
  border: 1px solid #f0cfcc;
  border-radius: 10px;
  color: #a34540;
  display: flex;
  font-size: 10px;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
}

.form-error svg {
  flex: 0 0 auto;
  height: 18px;
  width: 18px;
}

.submit-button {
  align-items: center;
  background: #0e4339;
  border: 0;
  border-radius: 12px;
  color: #fff;
  display: flex;
  font-size: 12px;
  font-weight: 720;
  gap: 9px;
  height: 50px;
  justify-content: center;
  margin-top: 16px;
  transition: background 180ms ease, transform 180ms ease;
  width: 100%;
}

.submit-button:hover:not(:disabled) {
  background: #0f5b4b;
  transform: translateY(-1px);
}

.submit-button:disabled {
  cursor: wait;
  opacity: 0.72;
}

.submit-button svg {
  height: 19px;
  width: 19px;
}

.form-spinner {
  animation: spinner 700ms linear infinite;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  border-top-color: #fff;
  height: 17px;
  width: 17px;
}

.consultation-guide {
  background: #102f2b;
  color: #fff;
  padding: 30px 27px;
  position: sticky;
  top: 172px;
}

.consultation-guide__label {
  align-items: center;
  color: #92cbb2;
  display: flex;
  font-size: 8px;
  font-weight: 800;
  gap: 8px;
  letter-spacing: 0.17em;
}

.consultation-guide__label span {
  background: #76cda5;
  border-radius: 50%;
  height: 6px;
  width: 6px;
}

.consultation-guide h3 {
  font-size: 23px;
  font-weight: 680;
  letter-spacing: -0.04em;
  line-height: 1.25;
  margin: 16px 0 25px;
}

.consultation-guide ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

.consultation-guide li {
  display: grid;
  gap: 11px;
  grid-template-columns: 27px minmax(0, 1fr);
  margin-top: 18px;
  position: relative;
}

.consultation-guide li:first-child {
  margin-top: 0;
}

.consultation-guide li > span {
  align-items: center;
  background: rgba(164, 229, 198, 0.11);
  border-radius: 50%;
  color: #9edaba;
  display: flex;
  font-size: 7px;
  font-weight: 750;
  height: 27px;
  justify-content: center;
  width: 27px;
}

.consultation-guide li strong {
  display: block;
  font-size: 11px;
  font-weight: 680;
  margin-top: 1px;
}

.consultation-guide li p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 9px;
  line-height: 1.5;
  margin: 5px 0 0;
}

.consultation-guide__note {
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 13px;
  display: flex;
  gap: 10px;
  margin-top: 26px;
  padding: 14px;
}

.consultation-guide__note svg {
  color: #92d7b5;
  flex: 0 0 auto;
  height: 19px;
  width: 19px;
}

.consultation-guide__note p {
  color: rgba(255, 255, 255, 0.72);
  font-size: 9px;
  line-height: 1.55;
  margin: 0;
}

.consultation-success {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 548px;
  text-align: center;
}

.consultation-success:focus {
  outline: none;
}

.consultation-success:focus-visible {
  box-shadow: 0 0 0 3px rgba(15, 107, 90, 0.2);
}

.consultation-success__icon {
  align-items: center;
  background: #e3f3e9;
  border-radius: 50%;
  color: #16805f;
  display: flex;
  height: 76px;
  justify-content: center;
  margin-bottom: 21px;
  width: 76px;
}

.consultation-success__icon svg {
  height: 42px;
  width: 42px;
}

.consultation-success__eyebrow {
  color: #2d8b6b;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.consultation-success h3 {
  font-size: 24px;
  font-weight: 720;
  letter-spacing: -0.04em;
  margin: 11px 0 0;
}

.consultation-success > p {
  color: #74827e;
  font-size: 12px;
  margin: 10px 0 0;
}

.consultation-success__reference {
  background: #f2f6f3;
  border-radius: 11px;
  display: flex;
  gap: 14px;
  margin-top: 23px;
  padding: 12px 18px;
}

.consultation-success__reference span {
  color: #86928e;
  font-size: 10px;
}

.consultation-success__reference strong {
  color: #214a40;
  font-size: 10px;
  letter-spacing: 0.05em;
}

.consultation-success button {
  background: #fff;
  border: 1px solid #cbd8d2;
  border-radius: 999px;
  color: #405b54;
  font-size: 10px;
  font-weight: 680;
  height: 38px;
  margin-top: 22px;
  padding: 0 17px;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(39, 139, 106, 0.2);
  outline-offset: 3px;
}

@keyframes panel-rise {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes visual-in {
  from {
    opacity: 0;
    transform: scale(1.02);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes orbit {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@keyframes orbit-reverse {
  to {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}
@keyframes pulse-soft {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(118, 213, 167, 0.2);
  }
  50% {
    box-shadow: 0 0 0 7px rgba(118, 213, 167, 0);
  }
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1000px) {
  .management-hero__inner {
    grid-template-columns: minmax(0, 1.05fr) minmax(300px, 0.95fr);
  }
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .consultation-layout {
    grid-template-columns: 1fr;
  }
  .consultation-guide {
    position: static;
  }
  .consultation-guide ol {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  }
  .consultation-guide li {
    margin-top: 0;
  }
}
@media (max-width: 780px) {
  .management-hero__inner {
    display: block;
    min-height: auto;
    padding: 48px 24px 55px;
  }
  .management-hero__visual::before {
    background: rgba(6, 45, 39, 0.75);
  }
  .management-hero__visual img {
    object-position: 58% center;
  }
  .visual-document-marker {
    display: none;
  }
  .management-tabs {
    top: 76px;
  }
  .management-tabs__inner {
    padding: 0 16px;
  }
  .management-tabs button {
    gap: 7px;
    height: 68px;
  }
  .management-tabs__copy small,
  .management-tabs__number {
    display: none;
  }
  .management-content {
    padding: 58px 22px 72px;
  }
  .definition-grid {
    grid-template-columns: 1fr;
  }
  .definition-grid article {
    min-height: 200px;
  }
  .feature-grid {
    grid-template-columns: 1fr;
  }
  .contract-note {
    align-items: flex-start;
    grid-template-columns: 46px minmax(0, 1fr);
  }
  .contract-note button {
    grid-column: 1/-1;
    justify-content: center;
    width: 100%;
  }
  .usage-summary {
    grid-template-columns: 1fr;
  }
  .contract-type-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-field--full {
    grid-column: auto;
  }
}
@media (max-width: 640px) {
  .management-tabs {
    top: 68px;
  }
}
@media (max-width: 560px) {
  .management-hero__inner {
    padding-left: 20px;
    padding-right: 20px;
  }
  .management-hero h1 {
    font-size: 40px;
  }
  .management-hero__copy > p br {
    display: none;
  }
  .management-hero__actions {
    align-items: stretch;
    flex-direction: column;
  }
  .hero-primary,
  .hero-secondary {
    width: 100%;
  }
  .management-tabs__inner {
    padding: 0 6px;
  }
  .management-tabs button {
    font-size: 12px;
    height: 62px;
  }
  .management-tabs button::after {
    width: 58px;
  }
  .management-content {
    padding: 46px 18px 62px;
  }
  .section-heading {
    margin-bottom: 32px;
  }
  .section-heading p br {
    display: none;
  }
  .section-heading__notice {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    margin-top: 18px;
    padding: 14px;
  }
  .section-heading__notice-copy {
    font-size: 13px;
  }
  .definition-statement {
    border-radius: 20px;
    padding: 36px 24px 30px;
  }
  .definition-statement p {
    font-size: 19px;
  }
  .definition-statement p br {
    display: none;
  }
  .definition-grid article {
    border-radius: 17px;
  }
  .feature-cta {
    align-items: stretch;
    flex-direction: column;
    gap: 17px;
  }
  .usage-step {
    gap: 16px;
    grid-template-columns: 40px minmax(0, 1fr);
  }
  .usage-step__rail span {
    border-width: 5px;
    height: 40px;
    width: 40px;
  }
  .usage-summary {
    border-radius: 20px;
    padding: 28px 20px;
  }
  .usage-summary__visual span {
    height: 48px;
    width: 48px;
  }
  .usage-summary__visual i {
    width: 10px;
  }
  .consultation-form-card {
    border-radius: 18px;
    min-height: auto;
    padding: 22px 18px;
  }
  .form-intro {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .consultation-guide {
    border-radius: 18px;
    padding: 25px 21px;
  }
  .consultation-guide ol {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .management-hero__copy,
  .management-hero__visual,
  .tab-panel,
  .form-spinner {
    animation: none;
  }
  html {
    scroll-behavior: auto;
  }
}`],
})
export class PageIpManagementComponent implements OnInit {
    public activeTab: string = 'definition';
    public submitting: boolean = false;
    public submitSuccess: boolean = false;
    public formError: string = '';
    public fieldErrors: any = {};
    public reference: string = '';

    public tabs: any[] = [
        { id: 'definition', number: '01', label: '정의', caption: '서비스 이해' },
        { id: 'features', number: '02', label: '특징', caption: '핵심 기능' },
        { id: 'usage', number: '03', label: '사용방법', caption: '업무 흐름' },
        { id: 'consultation', number: '04', label: '상담신청', caption: '도입 문의' }
    ];

    public contractTypes: any[] = [
        { id: 'A', label: 'A 타입', people: '3명 이내', price: '10만원', priceNote: '' },
        { id: 'B', label: 'B 타입', people: '6명 이내', price: '15만원', priceNote: '' },
        { id: 'C', label: 'C 타입', people: '10명 이내', price: '20만원', priceNote: '' },
        { id: 'D', label: 'D 타입', people: '10명 초과', price: '20만원 +', priceNote: '초과 1인당 1만원' }
    ];

    public features: any[] = [
        {
            number: '01',
            tag: 'CASE',
            title: '권리별 사건 통합 관리',
            description: '특허·실용신안, 상표, 디자인과 심판·소송 사건을 한곳에서 관리합니다.',
            points: ['진행 단계·권리·출원인 필터', '담당자와 다음 업무 확인']
        },
        {
            number: '02',
            tag: 'CONSULT',
            title: '상담에서 사건까지 연결',
            description: '신규 상담 내용과 고객 이력, 견적 정보를 사건 등록 흐름으로 자연스럽게 이어갑니다.',
            points: ['기존 고객·상담 이력 불러오기', '공통·권리별 추가정보 등록']
        },
        {
            number: '03',
            tag: 'DEADLINE',
            title: '기한과 일정 추적',
            description: '법정기한과 직접 지정한 업무 일정을 달력에서 확인하고 놓치지 않도록 관리합니다.',
            points: ['7일 전·마감일 일정 확인', '대시보드 업무 현황 연동']
        },
        {
            number: '04',
            tag: 'DOCUMENT',
            title: '서류와 발송 이력 관리',
            description: '사건별 서류를 업로드하고 열람·발송 상태와 후속 기한을 함께 기록합니다.',
            points: ['사건별 문서 분류', '발송·후속 업무 연결']
        },
        {
            number: '05',
            tag: 'CLIENT & QUOTE',
            title: '고객과 견적 정보 관리',
            description: '고객별 상담·관련 사건을 확인하고 권리별 견적과 발송 이력을 관리합니다.',
            points: ['고객 중심 통합 이력', '견적 템플릿과 비용 항목']
        },
        {
            number: '06',
            tag: 'KNOWLEDGE',
            title: '실무 정보 빠른 연결',
            description: '공지, 법령·기준, 언론보도, 업무 양식과 외부 IP 정보를 업무 중 바로 확인합니다.',
            points: ['업무 자료 모아보기', '지식재산처·KIPRIS 연결']
        }
    ];

    public steps: any[] = [
        {
            number: '01',
            label: 'CONSULTATION',
            title: '상담·접수 등록',
            description: '고객 정보와 권리 유형, 문의 내용 및 전달받은 서류를 상담 건으로 등록합니다.',
            chips: ['고객 정보', '권리 유형', '문의·서류']
        },
        {
            number: '02',
            label: 'REVIEW & QUOTE',
            title: '이력 확인과 견적 작성',
            description: '기존 고객과 상담 이력을 불러오고 업무 범위에 맞는 권리별 견적을 작성합니다.',
            chips: ['상담 이력', '견적 템플릿', '비용 항목']
        },
        {
            number: '03',
            label: 'CASE OPEN',
            title: '상담을 사건으로 전환',
            description: '확정된 상담을 사건으로 연결해 공통정보, 권리별 추가정보와 담당자를 등록합니다.',
            chips: ['공통정보', '추가정보', '담당자']
        },
        {
            number: '04',
            label: 'WORKFLOW',
            title: '서류·기한·진행 단계 관리',
            description: '사건 상세에서 서류 발송과 후속 기한을 지정하고 현재 진행 단계를 갱신합니다.',
            chips: ['서류 발송', '법정·수동 기한', '진행 단계']
        },
        {
            number: '05',
            label: 'MONITORING',
            title: '대시보드와 달력 확인',
            description: '담당 업무와 예정 일정을 지속적으로 확인해 중요한 업무를 놓치지 않습니다.',
            chips: ['업무 현황', '기한 달력', '알림 일정']
        }
    ];

    public form: any = this.emptyForm();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        document.title = '웅빈 미니홈';

        const root = document.querySelector('app-root') as HTMLElement;
        if (root) root.scrollTop = 0;

        this.activateFromHash();
        await this.service.render();

        if (this.activeTab !== 'definition') this.scrollToTabs();
    }

    @HostListener('window:hashchange')
    public async onHashChange() {
        this.activateFromHash();
        await this.service.render();
        this.scrollToTabs();
    }

    public async goHome() {
        this.service.href('/home');
    }

    public async switchTab(tabId: string) {
        if (!this.tabs.some((tab: any) => tab.id === tabId)) return;
        this.activeTab = tabId;
        this.formError = '';
        history.replaceState({}, '', '/ip-management#' + tabId);
        await this.service.render();
        this.scrollToTabs();
    }

    public async onTabKeydown(event: any, tabId: string) {
        const supported = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (supported.indexOf(event.key) < 0) return;

        event.preventDefault();
        const currentIndex = this.tabs.findIndex((tab: any) => tab.id === tabId);
        if (currentIndex < 0) return;

        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        const nextTab = this.tabs[nextIndex];
        await this.switchTab(nextTab.id);

        const target = document.getElementById('tab-' + nextTab.id) as HTMLElement;
        if (target) target.focus();
    }

    public async submitConsultation() {
        if (this.submitting) return;

        this.submitSuccess = false;
        this.formError = '';
        this.reference = '';
        this.formError = this.validateForm();
        if (this.formError) {
            await this.service.render();
            this.focusFirstInvalid();
            return;
        }

        this.submitting = true;
        await this.service.render();

        try {
            const payload = JSON.parse(JSON.stringify(this.form));
            payload.phone = normalizePhone(payload.phone);
            payload.email = payload.email.trim();
            const { code, data } = await wiz.call('submit_consultation', payload);

            if (code === 200) {
                this.reference = data && data.reference ? data.reference : '';
                this.submitSuccess = true;
            } else {
                const errorType = data && data.error_type ? data.error_type : '';
                if (errorType === 'validation') {
                    this.formError = data && data.message
                        ? data.message
                        : '입력값을 확인한 후 다시 시도해 주세요.';
                } else if (errorType === 'network') {
                    this.formError = '상담 접수 서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.';
                } else {
                    this.formError = data && data.message
                        ? data.message
                        : '상담 신청을 접수하지 못했습니다. 잠시 후 다시 시도해 주세요.';
                }
            }
        } catch (error) {
            this.formError = '웅빈 미니홈 서버와의 네트워크 연결을 확인한 후 다시 시도해 주세요.';
        }

        this.submitting = false;
        await this.service.render();

        if (this.submitSuccess) {
            this.scrollToTabs();
            const successRegion = document.getElementById('consultation-success') as HTMLElement;
            if (successRegion) successRegion.focus();
        }
    }

    public async resetForm() {
        this.form = this.emptyForm();
        this.submitSuccess = false;
        this.formError = '';
        this.fieldErrors = {};
        this.reference = '';
        await this.service.render();

        const firstField = document.querySelector('[name="contractType"]') as HTMLElement;
        if (firstField) firstField.focus();
    }

    private activateFromHash() {
        const hash = location.hash.replace('#', '');
        if (this.tabs.some((tab: any) => tab.id === hash)) {
            this.activeTab = hash;
        }
    }

    private validateForm() {
        const errors: any = {};

        if (!this.contractTypes.some((contractType: any) => contractType.id === this.form.contractType)) {
            errors.contractType = '계약 타입을 선택해 주세요.';
        }

        if (!this.form.officeName.trim()) {
            errors.officeName = '사무소명을 입력해 주세요.';
        }

        if (!this.form.contactName.trim()) {
            errors.contactName = '상담자(담당자) 성함을 입력해 주세요.';
        }


        if (!this.form.phone.trim()) {
            errors.phone = '연락처를 입력해 주세요.';
        } else if (normalizePhone(this.form.phone) === null) {
            errors.phone = '연락 가능한 전화번호를 정확히 입력해 주세요.';
        }

        if (!this.form.email.trim()) {
            errors.email = '이메일을 입력해 주세요.';
        } else if (!validEmail(this.form.email, 180)) {
            errors.email = '이메일 형식을 확인해 주세요.';
        }

        if (!this.form.inquiry.trim()) {
            errors.inquiry = '문의내용을 입력해 주세요.';
        } else if (this.form.inquiry.trim().length < 10) {
            errors.inquiry = '문의내용을 10자 이상 입력해 주세요.';
        }

        if (!this.form.privacy) {
            errors.privacy = '개인정보 수집 및 이용에 동의해 주세요.';
        }

        const limits: any = {officeName: 100, contactName: 60, phone: 30, email: 180, inquiry: 2000};
        for (const key of Object.keys(limits)) {
            if (String(this.form[key] || '').trim().length > limits[key]) errors[key] = limits[key] + '자 이하로 입력해 주세요.';
        }
        this.fieldErrors = errors;
        const order = ['contractType', 'officeName', 'contactName', 'phone', 'email', 'inquiry', 'privacy'];

        for (const key of order) {
            if (errors[key]) return errors[key];
        }

        return '';
    }

    private focusFirstInvalid() {
        const order = ['contractType', 'officeName', 'contactName', 'phone', 'email', 'inquiry', 'privacy'];
        const first = order.find((key: string) => !!this.fieldErrors[key]);
        if (!first) return;

        const target = document.querySelector('[name="' + first + '"]') as HTMLElement;
        if (target) target.focus();
    }

    private emptyForm() {
        return {
            contractType: '',
            officeName: '',
            contactName: '',
            phone: '',
            email: '',
            inquiry: '',
            privacy: false,
            website: ''
        };
    }

    private scrollToTabs() {
        const root = document.querySelector('app-root') as HTMLElement;
        const header = document.querySelector('.public-header') as HTMLElement;
        const tabs = document.querySelector('.management-tabs') as HTMLElement;
        const content = document.querySelector('.management-content') as HTMLElement;
        if (!root || !tabs || !content) return;

        const offset = (header ? header.offsetHeight : 76) + tabs.offsetHeight;
        const top = content.getBoundingClientRect().top + root.scrollTop - offset;
        const behavior: ScrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth';

        root.scrollTo({ top, behavior });
    }
}

export default PageIpManagementComponent;